import { createAsyncThunk } from "@reduxjs/toolkit";

import { Api } from "../..";
import { CustomAction } from "../../store/customAction";
import {
  API_GET_IA_CUSTOM_RANGE,
  API_GET_IA_METRICS,
} from "../../Apis/ApiEndPoints";
import {
  IGetAllIAMetricsResponse,
  IGetIAMetricsByFilterResponse,
  IIAPerformanceFilters,
} from "../../models/admin/InsureAssistPerformance/InsureAssistPerformance";

export const getAllIAMetrics = createAsyncThunk(
  "all/getAllIAMetrics",
  async (_, { dispatch }) => {
    const response: IGetAllIAMetricsResponse = await CustomAction(
      Api.get(API_GET_IA_METRICS),
      dispatch,
      "all/getAllIAMetrics"
    );
    return response;
  }
);

export const getIAMetricsByFilter = createAsyncThunk(
  "filters/insureAssistMetrics",
  async (requestParams: IIAPerformanceFilters, { dispatch }) => {
    let apiUrl = `${API_GET_IA_CUSTOM_RANGE}?`;
    if (requestParams.fromDate) {
      apiUrl += `fromDate=${requestParams.fromDate}&`;
    }
    if (requestParams.toDate) {
      apiUrl += `toDate=${requestParams.toDate}&`;
    }

    apiUrl = apiUrl.endsWith("&") ? apiUrl.slice(0, -1) : apiUrl;

    const response: IGetIAMetricsByFilterResponse = await CustomAction(
      Api.get(apiUrl),
      dispatch,
      "filters/insureAssistMetrics"
    );
    return response;
  }
);
